import schema, { generateType } from './Schema';
export const Lead = generateType(schema.getModel('lead'));
//# sourceMappingURL=LeadModel.js.map